export default "__VITE_ASSET__DmIGIRZi__"